import Image from "../Quicklinks/Image.Quicklinks";
import Redirect from "../Quicklinks/Redirect.Quicklinks";
import TextQuickLinks from "../Quicklinks/Text.Quicklinks";

const quickLinkTypes = {
  "image-quicklinks": Image,
  "redirect-quicklinks": Redirect,
  "text-quicklinks": TextQuickLinks,
}
export {
  quickLinkTypes
}